export default "__VITE_ASSET__CrPStdni__"